import React, { Component } from 'react';
import '../Styles/PageNotFound.scss';

export default class PageNotFound extends Component {  
  render (){
    return (
      <div className="pnpCont">
        <h2>404</h2>
        <h3>Page Not Found</h3>
        <p>The page you are looking for was moved, removed,<br/>renamed or might never existed. </p>
      </div>
    );
  }
}